// 開くボタン処理
document.querySelectorAll('.js-modal-open').forEach(button => {
    button.addEventListener('click', () => {
      const targetId = button.dataset.target;
      const targetModal = document.getElementById(targetId);
      
      if (targetModal) {
        targetModal.showModal();
      }
    });
  });
  
  // 閉じるボタンで閉じる
  document.querySelectorAll('.js-modal-close').forEach(button => {
    button.addEventListener('click', () => {
      const modal = button.closest('dialog');
      if (modal) {
        modal.close();
      }
    });
  });
  
  // 背景（::backdrop）クリックで閉じる
  document.querySelectorAll('dialog.c-modal').forEach(modal => {
    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        modal.close();
      }
    });
  });